import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import FlightSegment from '../entities/flight/flightSegment';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface FlightSegmentState extends ListState<FlightSegment> {
  flightSegment: FlightSegment;
  editFlightSegment: FlightSegment;
}

class FlightSegmentMutations extends ListMutations<FlightSegment> {}

class FlightSegmentModule extends ListModule<
  FlightSegmentState,
  any,
  FlightSegment
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<FlightSegment>(),
    loading: false,
    editFlightSegment: new FlightSegment(),
    selectFlightSegment: new FlightSegment(),
  };
  actions = {
    async selectFlightSegment(
      context: ActionContext<FlightSegmentState, any>,
      payload: any
    ) {
      context.state.editFlightSegment = payload.data;
    },

    async saveFlightSegment(
      context: ActionContext<FlightSegmentState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveFlightSegment',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightSegment>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateFlightSegment(
      context: ActionContext<FlightSegmentState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateFlightSegment',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightSegment>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getFlightSegments(
      context: ActionContext<FlightSegmentState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetFlightSegments',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<FlightSegment>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteFlightSegment(
      context: ActionContext<FlightSegmentState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteFlightSegment?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: FlightSegmentState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightSegmentState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightSegmentModule = new FlightSegmentModule();
export default flightSegmentModule;
